var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEm4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Very Confident"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 21.9997C44 34.1497 34.1811 43.9995 22.0693 43.9995C9.95751 43.9995 0.138641 34.1497 0.138641 21.9997C0.138641 9.84931 9.95751 0 22.0693 0C34.1811 0 44 9.84979 44 21.9997Z",
    fill: "#DAE7F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66219 22.087C4.35349 9.93561 9.81023 3.66318 19.1639 0.17395C8.35794 1.53882 0 10.79 0 21.9998C0 34.1503 9.81887 44 21.9307 44C23.9543 44 25.913 43.7236 27.7734 43.2088C26.8675 43.3229 25.9428 43.4298 25.0071 43.3822C14.9765 42.8702 4.97089 34.2331 4.66219 22.087Z",
    fill: "#B5C4D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8194 25.0859C14.8194 25.0859 17.8637 28.3174 21.9858 28.107C24.4458 27.9822 26.7142 26.7021 27.6595 26.0082C31.5901 23.1209 29.2544 32.8922 20.329 31.4089C12.5347 30.1134 12.6869 24.6129 14.8194 25.0859Z",
    fill: "#8D9FB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82689 21.3703C6.82689 21.3703 8.90809 19.1611 11.7262 19.3042C13.408 19.3899 14.9587 20.265 15.6049 20.7398C18.292 22.7139 17.1451 15.1079 11.0435 16.1217C5.71451 17.0074 5.36884 21.6929 6.82689 21.3703Z",
    fill: "#8D9FB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.245 21.3703C36.245 21.3703 34.1638 19.1611 31.3457 19.3042C29.6639 19.3899 28.1132 20.265 27.467 20.7398C24.7799 22.7139 25.9269 15.1079 32.0284 16.1217C37.3574 17.0074 37.7031 21.6929 36.245 21.3703Z",
    fill: "#8D9FB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54264 12.7264C6.54264 12.7264 7.27957 12.5294 8.34826 12.317C9.79142 12.029 11.84 11.714 13.4905 11.8176C16.3634 11.9977 14.3067 8.99009 9.35166 10.0882C4.3971 11.1867 5.26271 13.0274 6.54264 12.7264Z",
    fill: "#8D9FB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5115 12.2333C35.5115 12.2333 34.7746 12.0368 33.7059 11.824C32.2627 11.5365 30.2141 11.221 28.5636 11.3246C25.6907 11.5047 27.7474 8.49705 32.7025 9.59511C37.657 10.6941 36.7914 12.5343 35.5115 12.2333Z",
    fill: "#8D9FB6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEm4);
export default __webpack_public_path__ + "static/media/em4.93852fecb0ff31e36d2cebcaa74f8fb9.svg";
export { ForwardRef as ReactComponent };